import useGroupsContext from '@contexts/GroupsContext/hook';
import useFeaturePermissionsContext from '@contexts/FeaturePermissionsContext/hook';
import { permiteProduto } from '@utils/permissionFilter';
import { produtosAlcancados } from '@utils/produtosAlcancados';
import { subconjuntosDoPainel } from '@utils/subconjuntosDoPainel';

/**
 * As comunidades que o painel tem como servir: permissão de ver a tela E escopo que alguma família
 * admita.
 *
 * **Uma resposta, três consumidores**, e é o ponto: o portão, a LISTA do seletor e a partição em
 * famílias precisam concordar. Divergir entre eles produz três defeitos diferentes com a mesma cara
 * de "tela aberta e vazia":
 *
 *   - portão sem a permissão      -> abre, e a lista vem vazia;
 *   - lista sem o escopo          -> o seletor afirma incluir uma comunidade que todo agregado omite;
 *   - lista sem a permissão       -> escolher manda requisição que a API recusa.
 *
 * Os dois critérios são independentes e os dois são necessários: `report_scope` e `dashboard:view`
 * são campos diferentes do mesmo grant, e a Central permite qualquer combinação deles.
 */
export const useComunidadesQueOPainelServe = () => {
  const { groups, escopoPorProduto } = useGroupsContext();
  const { getUserPermissions } = useFeaturePermissionsContext();

  const comPermissao = produtosAlcancados(groups)
    .map((produto) => Number(produto.id))
    .filter((id) =>
      permiteProduto(
        getUserPermissions,
        { feature: 'dashboard', action: 'view' },
        id,
      ),
    );

  const subconjuntos = subconjuntosDoPainel(comPermissao, escopoPorProduto);

  /*
    A união das duas famílias, e não `comPermissao`: comunidade cujo escopo nenhuma família admite —
    indicação, ou comissão sem papel — fica fora. Ela existe e a pessoa até pode ver o painel dela,
    mas nenhum bloco sabe somá-la.
  */
  return [...new Set([...subconjuntos.produtor, ...subconjuntos.afiliado])];
};
